import React from 'react';
import styled from '@benzinga/themetron';
import { noop } from '@benzinga/utils';

interface WrapperProps {
  $bottom?: React.CSSProperties['bottom'];
  $cursor?: React.CSSProperties['cursor'];
  $left?: React.CSSProperties['left'];
  $right?: React.CSSProperties['right'];
  $top?: React.CSSProperties['top'];
}

interface Props {
  bottom?: React.CSSProperties['bottom'];
  content?: string;
  left?: React.CSSProperties['left'];
  onClickHandler?: React.MouseEventHandler<HTMLDivElement>;
  right?: React.CSSProperties['right'];
  top?: React.CSSProperties['top'];
}

export const Tooltip: React.FC<Props> = ({ bottom, content, left, onClickHandler = noop, right, top }) => (
  <TooltipWrapper $bottom={bottom} $cursor={'pointer'} $left={left} $right={right} $top={top} onClick={onClickHandler}>
    {content}
  </TooltipWrapper>
);

const TooltipWrapper = styled.div<WrapperProps>`
  bottom: ${props => props.$bottom};
  cursor: ${props => props.$cursor};
  left: ${props => props.$left};
  right: ${props => props.$right};
  top: ${props => props.$top};

  background: ${props => props.theme.colors.brand};
  box-shadow:
    0 3px 6px rgba(0, 0, 0, 0.16),
    0 3px 6px rgba(0, 0, 0, 0.23);
  color: ${props => props.theme.colors.brandForeground};
  cursor: pointer;
  font-size: 0.9em;
  font-weight: lighter;
  padding: 8px 15px;
  position: absolute;
  text-align: center;
  &:before {
    border: solid transparent;
    bottom: 100%;
    content: ' ';
    left: 50% + 9px;
    position: absolute;
    border-bottom-color: ${props => props.theme.colors.brand};
    border-width: 9px;
    margin-left: -18px;
  }
`;

TooltipWrapper.defaultProps = {
  $bottom: 'auto',
  $left: 'auto',
  $right: 'auto',
  $top: 'auto',
};
